import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Spin, message } from "antd";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { AuthService } from "../../Services/AuthService";
import { LoadingOutlined } from "@ant-design/icons";
import { useUser } from "../../Context/UserContext";
import ClientServiceNew from "../../../src/CapsitechAccountsComponents/Services/ClientService";
import { IUserProfile } from "../../Types";
import { useDispatch } from "react-redux";
import { setLoginUserData } from "../../CapsitechAccountsComponents/Redex/UserSlice";
import logo from "../../CapsitechAccountsComponents/Images/CapsitechAccounts.svg";
import { MD5 } from "crypto-js";
import { IRole, useRole } from "../../Context/RoleContext";
import { CapsiAccountLogo } from "../../CapsitechAccountsComponents/Common/Icon";

const Login = (props: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 14, color: "white" }} spin />
  );
  const { setCurrentUser } = useUser();
  const { setCurrentRole } = useRole();
  const { setIsLoggedIn } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [isForgotpass, setIsforgotpass] = useState(false);
  const [userEmail, setUserEmail] = React.useState<any>();
  const [userData, setUserData] = React.useState<IUserProfile>();
  const [forgotMail, setForgotMail] = React.useState<any>();

  console.log("userData", userData);

  const UserLogin = () => {
    form
      .validateFields()
      .then(async (val) => {
        // var hashValue = val.password;
        var hashValue = MD5(val.password).toString();

        setLoading(true);
        await AuthService.login(val.username, hashValue)
          .then((user: any) => {
            console.log("User Data: ", user);

            if (user?.token != null) {
              //update usercontext value before switching to dashboard
              setCurrentUser(user);

              if (!user?.clientSpecificRole) {
                const contextSet: IRole[] = [
                  {
                    clientIdList:
                      user?.clientRoleList?.length > 0
                        ? user?.clientRoleList[0]?.id
                        : [],
                    roleId:
                      user?.clientRoleList?.length > 0
                        ? user?.clientRoleList[0]?.roleId
                        : [],
                    roleName: user?.role,
                    description: user?.roleDescription,
                    accessSettings: user?.accessSettings,
                  },
                ];
                setCurrentRole(contextSet);
                // Utils.setLocal("RoleList", contextSet);
              } else {
                const x: IRole[] = [
                  // {
                  //   clientIdList: [],
                  //   roleId: "",
                  //   roleName: "",
                  //   description: "",
                  //   accessSettings: [],
                  // },
                ];
                // setCurrentRole(x);
                // Utils.setLocal("RoleList", x);
              }
              setUserData(user);
              // setIsLoggedIn(true);
              dispatch(setLoginUserData(user));

              sessionStorage.setItem("state", JSON.stringify(true));
              localStorage.setItem(
                "ci-config",
                JSON.stringify({
                  darkMode: false,
                  themeColor: "#004B8B",
                  fontSize: 14,
                  borderRadius: 6,
                  componentSize: "middle",
                  tablePageSize: 15,
                  silderSize: true,
                  zebraStriped: true,
                })
              );
            }
            setLoading(false);
          })
          .catch((ex) => {
            console.error("Login error", ex);
            setLoading(false);
          });
      })
      .catch((ex) => {
        console.error("Login error", ex);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (userData) {
      const getState = async () => {
        await ClientServiceNew.getStateOption(true)
          .then((res: any) => {
            if (res.status) {
              const result = res?.result;
              result.shift();
              localStorage.setItem("IndianState", JSON.stringify(result));
              setCurrentUser(userData, result);

              userData?.customerId
                ? navigate("/books")
                : navigate("/books/customer");
              // userData?.companyList?.length === 1
              //   ? navigate(
              //       `/books/clients/${userData?.companyList?.[0]}/dashboard`
              //     )
              //   : navigate("/books");
              // dispatch(setIndianState(result));
            }
            // setStatesOption(res?.result);
          })
          .catch((ex) => {
            console.error("Login error", ex);
            setLoading(false);
          });
      };
      getState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const [cardWidth, setcardWidth] = useState(window.innerWidth);
  window.addEventListener("resize", () => {
    setcardWidth(window.innerWidth);
  });
  if (JSON.parse(localStorage.getItem("LockPeriod")!)) {
    localStorage.removeItem("LockPeriod");
  }
  const [messageApi, contextHolder] = message.useMessage();
  const info = (msg: any) => {
    messageApi.success(msg);
  };
  useEffect(() => {
    if (!localStorage.getItem("projecttype")) {
      localStorage.setItem("projecttype", "books");
    }
    if (localStorage.getItem("RoleList")) {
      localStorage.removeItem("RoleList");
    }
    // if()
  }, []);

  const [ForgotPasswordForm] = Form.useForm();

  const error = (mes: any) => {
    messageApi.error(mes);
  };
  const [loadings, setLoadings] = useState<boolean[]>([]);
  const enterLoading = (index: number) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 1000);
  };

  const postMail = () => {
    setLoading(true);
    enterLoading(1);
    //  /auth/forgotpassword
    ForgotPasswordForm.validateFields().then((val: any) => {
      console.log(val);
      setLoading(false);

      AuthService.forgotpassword(forgotMail).then((res: any) => {
        console.log("res ================================== ", res);
        if (res) {
          info(
            "We have sent you an email to reset your password,Please check your inbox"
          );
          // console.log(val, "asdkfasdflsdlf;jsdlfjsdlfjlsdkjkl")
          console.log(res);
          ForgotPasswordForm.resetFields();
        } else {
          error("Something went to wrong");
          ForgotPasswordForm.resetFields();
        }
      });
    });
  };

  return (
    <>
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            zIndex: -1,
            height: "20%",
            width: "100%",
            backgroundColor: "#004B8B",
          }}
        ></div>
        <div
          style={{
            position: "fixed",
            bottom: 0,
            zIndex: -1,
            height: "20%",
            width: "100%",
            backgroundColor: "#fff",
          }}
        ></div>
        <div className="login-container">
          <div className="login-illustration">
            <h1 className="h1">Book-keeping System</h1>
            <p className="p">
              Our book-keeping project simplifies invoicing and payment tracking
            </p>
            <div className="invoice-illustration">
              <img
                src="https://www.slnsoftwares.com/images/gst-software/GST-billing-software.png"
                alt="Invoice Illustration"
              />
            </div>
          </div>

          <div className="login-form-section">
            <div className="form-content">
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 24,
                }}
              >
                <div>
                  <CapsiAccountLogo />
                </div>
                <div style={{ fontSize: 45, fontWeight: 400 }}>
                  &nbsp;<span style={{ fontWeight: 600 }}> Capsi</span> Books
                </div>
              </div>
              {isForgotpass !== true ? (
                <>
                  <h2 style={{ textAlign: "center", marginTop: "30px" }}>
                    Welcome
                  </h2>
                </>
              ) : (
                <>
                  <p style={{ marginTop: "30px" }}></p>
                </>
              )}
              <p style={{ textAlign: "center", fontSize: "17px" }}>
                Please login to continue your account
              </p>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  paddingTop: "20px",
                  paddingLeft: "11px",
                }}
              >
                {isForgotpass !== true ? (
                  <></>
                ) : (
                  <> Send mail for new password and sign in.</>
                )}
              </p>
              {contextHolder}
              {isForgotpass !== true ? (
                <>
                  <Form
                    form={form}
                    layout="vertical"
                    style={{ marginTop: "50px" }}
                    requiredMark={false}
                  >
                    <span style={{ fontSize: "15px", paddingLeft: "4px" }}>
                      Email Id
                    </span>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your username",
                        },
                        { type: "email", message: "Invalid Email" },
                      ]}
                      className="no-autofill-padding"
                    >
                      <Input
                        placeholder="Enter your email"
                        autoFocus
                        onChange={(e: any) => {
                          setUserEmail(e.target.value);
                        }}
                      />
                    </Form.Item>
                    <span style={{ fontSize: "15px", paddingLeft: "4px" }}>
                      Password
                    </span>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your password",
                        },
                      ]}
                      className="no-autofill-padding"
                    >
                      <Input.Password placeholder="Enter your password" />
                    </Form.Item>

                    <div className="forgot-password">
                      <Link onClick={() => setIsforgotpass(true)} to={""}>
                        Forgot password ?
                      </Link>{" "}
                    </div>

                    <Form.Item style={{ marginTop: "23px" }}>
                      <Button
                        onClick={() => UserLogin()}
                        type="primary"
                        htmlType="submit"
                        block
                        className="custom-login-button"
                      >
                        {loading ? <Spin indicator={antIcon} /> : "LOG IN"}
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ) : (
                <>
                  <Form
                    requiredMark={false}
                    form={ForgotPasswordForm}
                    name="ForgotPassword"
                    layout="vertical"
                    initialValues={{ email: userEmail }}
                  >
                    <Row style={{ marginTop: "40px" }}>
                      <Col lg={24}>
                        <span style={{ fontSize: "15px", paddingLeft: "4px" }}>
                          Enter Your Email
                        </span>
                        <Form.Item
                          className="no-autofill-padding"
                          name="email"
                          style={{ marginBottom: "20px" }}
                          rules={[
                            { required: true, message: "Required" },
                            { type: "email", message: "Invalid email" },
                          ]}
                        >
                          <Input
                            placeholder="example@gmail.com"
                            onChange={(e: any) => setForgotMail(e.target.value)}
                          />
                        </Form.Item>
                        <Row justify={"end"}>
                          <Col>
                            <Link
                              to={""}
                              onClick={() => setIsforgotpass(!isForgotpass)}
                            >
                              Back to Login
                            </Link>
                          </Col>
                        </Row>
                        <Button
                          type="primary"
                          loading={loadings[1]}
                          onClick={postMail}
                          htmlType="submit"
                          block
                          style={{ marginTop: "20px" }}
                        >
                          Send Mail
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default Login;
